import { useRef } from "react";
import {
  Backdrop,
  Box,
  Button,
  Fade,
  makeStyles,
  Modal,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentStyles from "assets/theme/views/admin/dashboard";
import { IsMobile } from "utils/is-mobile";

const ACCEPTED_FILE_TYPE = "image/jpeg";

const useStyles = makeStyles(componentStyles);
const useMyStyles = makeStyles(() => ({
  th: {
    color: "#32325d",
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 600,
    lineHeight: 1.5,
    marginBottom: ".5rem",
    textAlign: "center",
    paddingBottom: "15px",
  },
  td: {
    fontSize: ".75rem",
    fontFamily: "inherit",
    fontWeight: 500,
    textAlign: "center",
    padding: "10px 0px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
}));
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

const isDefaultImage = (url) =>
  url?.split("/").pop() === "ProdutoSemImagem.png";

export default function ModalShowImage({
  showingPhoto,
  setShowingPhoto,
  loading,
  setLoading,
  handleDeleteImage,
  handleFileChange,
}) {
  const classes = {
    ...useStyles(),
    ...useStylesCardDeck(),
    ...useMyStyles(),
  };
  const isMobile = IsMobile();

  const verifyProfiles = JSON.parse(localStorage.getItem("userProfiles"));
  const verifyProfilesVision = JSON.parse(
    localStorage.getItem("userProfilesVision")
  );

  const userProfiles = verifyProfilesVision
    ? verifyProfilesVision
    : verifyProfiles;

  const isAgent = userProfiles.find((profile) =>
    ["ADM", "CRC", "SUPORTE", "KEY USER"].includes(profile.NomePerfil)
  );

  const fileInputRef = useRef(null);

  const handleUploadPhoto = () => {
    fileInputRef.current?.click();
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={Boolean(showingPhoto)}
        onClose={() => setShowingPhoto(null)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Fade in={Boolean(showingPhoto)}>
          <div
            className={classes.paper}
            style={{
              backgroundColor: "#FFF",
              padding: "20px",
              borderRadius: 8,
            }}
          >
            <Box
              display="flex"
              justifyContent={isMobile ? "space-around" : "flex-end"}
              marginBottom="1rem"
            >
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: isMobile ? 0 : "1rem",
                  cursor: "pointer",
                }}
                disabled={loading.delete}
                onClick={() => setShowingPhoto(null)}
              >
                <Typography variant="caption">Fechar</Typography>
                <CloseIcon
                  onClick={() => setShowingPhoto(null)}
                  disabled={loading.delete}
                  style={{ marginLeft: "0.5rem" }}
                />
              </Box>
            </Box>
            <Box>
              <img alt="" src={showingPhoto?.url} width={500} />
            </Box>
            <Box display="flex" justifyContent="center" marginTop="1rem">
              {isDefaultImage(showingPhoto?.url) ? (
                <Button
                  variant="contained"
                  color="default"
                  onClick={handleUploadPhoto}
                  disabled={loading.upload}
                >
                  {loading.upload ? "Enviando..." : "Enviar nova imagem"}
                  <CloudUploadIcon
                    style={{ width: 20, height: 20, marginLeft: 8 }}
                  />
                </Button>
              ) : loading.deleteConfirm ? (
                <Box>
                  <Typography as="p" color="initial">
                    Tem certeza que deseja deletar a foto?
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    marginTop="0.5rem"
                  >
                    <Button
                      variant="contained"
                      color="secondary"
                      style={{ marginRight: 12 }}
                      onClick={() =>
                        setLoading((prev) => ({
                          ...prev,
                          deleteConfirm: false,
                        }))
                      }
                      disabled={loading.delete}
                    >
                      Cancelar
                    </Button>
                    <Button
                      variant="contained"
                      color="default"
                      disabled={loading.delete}
                      onClick={handleDeleteImage}
                    >
                      {loading.delete ? "Removendo..." : "Remover"}
                    </Button>
                  </Box>
                </Box>
              ) : (
                <>
                  {isAgent && (
                    <Button
                      variant="contained"
                      color="default"
                      onClick={() =>
                        setLoading((prev) => ({ ...prev, deleteConfirm: true }))
                      }
                    >
                      Remover
                      <DeleteIcon
                        style={{ width: 20, height: 20, marginLeft: 8 }}
                      />
                    </Button>
                  )}
                </>
              )}
            </Box>
          </div>
        </Fade>
      </Modal>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={ACCEPTED_FILE_TYPE}
        style={{ display: "none" }}
      />
    </>
  );
}
